import { render, staticRenderFns } from "./default.vue?vue&type=template&id=db04ba06&"
import script from "./default.vue?vue&type=script&setup=true&lang=js&"
export * from "./default.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports